import request from '@/util/request'

// 获取教师列表（改造后从 users 表查询教师角色用户）
export function getTeacherList(params) {
  return request({
    url: '/users/teachers',
    method: 'get',
    params: params,
    headers: {"Content-Type": "application/json"},
  })
}
